import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const healthCheckStatus = z.object({
  serialNumber: z.number().nullable(),
  lastPing: z.date().nullable(),
});

export class HealthCheckStatus extends createZodDto(healthCheckStatus) {}
